/*
 * File: /src/store/modules/interests.js
 * Created Date: Sunday October 17th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 17th October 2021 6:44:22 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import contactServices from 'src/services/contactServices';
import interestServices from 'src/services/interestServices';

const state = {
  interests: []
};
const getters = {
  getInterests: state => state.interests
};
const actions = {
  async fetchInterests({ commit }) {
    if (state.interests.length === 0) {
      return interestServices.fetchInterests()
      .then( r => {
        commit('storeInterests', r.data);
      });
    }
  },
  unloadInterests({ commit }) {
    commit('storeInterests', []);
  },
  addContactToInterests({}, meta) {
    return new Promise(async (resolve, reject) => {
      const existingContact = (
        await contactServices.fetchContactById(meta.contact)
      ).data;
      const interests = Object.assign([], existingContact.interests);
      interests.push({ id: meta.interestId });
      contactServices
        .patchContact(meta.contact, { interests: interests })
        .then(r => {
          resolve(r.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  removeContactFromInterests({}, meta) {
    return new Promise(async (resolve, reject) => {
      const existingContact = (
        await contactServices.fetchContactById(meta.contact)
      ).data;
      const interests = existingContact.interests.filter(i => {
        if (+i.id !== +meta.interestId) return i;
      });
      contactServices
        .patchContact(meta.contact, { interests: interests })
        .then(r => {
          resolve(r.data);
        })
        .catch(e => {
          console.log(e);
          reject(e);
        });
    });
  }
};
const mutations = {
  storeInterests(state, interests) {
    state.interests = Object.assign([], interests);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
